<ng-template #createDealTeam>
  <div id="acceptDiv" *ngIf="showCreate">
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{header}} Deal Contact</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="dealContactForm" autocomplete="off">
        <div class="form-group">

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  First Name
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" formControlName="txtFirstName" placeholder="First Name" dropSpecialCharacters="false" maxlength="50" [(ngModel)]="dealContactInputModel.FirstName"
                         class="form-control " required>
                  <div *ngIf="(txtFirstName.invalid && isSubmitted)|| (txtFirstName.invalid && (txtFirstName.dirty || txtFirstName.touched))">
                    <p class="redtext" *ngIf="txtFirstName.errors.required">
                      First Name is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Last Name
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" formControlName="txtLastName" placeholder="Last Name" dropSpecialCharacters="false" maxlength="50" [(ngModel)]="dealContactInputModel.LastName"
                         class="form-control " required>
                  <div *ngIf="(txtLastName.invalid && isSubmitted)|| (txtLastName.invalid && (txtLastName.dirty || txtLastName.touched))">
                    <p class="redtext" *ngIf="txtLastName.errors.required">
                      Last Name is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Contact Type
                  <span class="star">*</span>
                </label>
                <label class="select">
                  <select class="form-control" formControlName="lstRole" [(ngModel)]="dealContactInputModel.ContactTypeId">
                    <option [ngValue]="null">Select</option>
                    <option *ngFor="let item of contactTypes" [(ngValue)]="item.Id">{{item.ContactType}}</option>
                  </select>
                  <i></i>
                </label>
                <div *ngIf="(lstRole.invalid && isSubmitted) ||(lstRole.invalid && (lstRole.dirty || lstRole.touched))">
                  <p class="redtext" *ngIf="lstRole.errors.required">
                    Contact Type is required
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Email
                </label>
                <div>
                  <input formControlName="txtEmail" placeholder="Email Address" [(ngModel)]="dealContactInputModel.Email"
                         class="form-control ">
                  <div *ngIf="(txtEmail.invalid && isSubmitted )||(txtEmail.invalid && (txtEmail.dirty || txtEmail.touched))">
                    <p class="redtext" *ngIf="txtEmail.errors.EmailCheck">
                      Invalid Email Address
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Phone
                </label>
                <div>
                  <input type="text" formControlName="txtPhone" placeholder="Phone Number" mask='(000) 000-0000' [(ngModel)]="dealContactInputModel.Phone"
                         class="form-control ">
                  <div *ngIf="(txtPhone.invalid && isSubmitted )||(txtPhone.invalid && (txtPhone.dirty || txtPhone.touched))">
                    <p class="redtext" *ngIf="txtPhone.errors.minlength">
                      Invalid Phone no.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!--<div class="form-group">
              <textarea class="form-control textarea-min-height" maxlength="4000"  required type="text" placeholder="Please enter comments"></textarea>
              <p class="redtext">Please enter comments </p>
          </div>-->
          <div class="text-right padding_15_0">
            <button class="btn btn-default btn-lg" id="closeModal" (click)="cancel()">Cancel</button>
            <button type="button"  class="btn btn-success btn-lg" *ngIf="isSubmitted">{{header}}</button>
            <button type="button" (click)="addDealTeam()" class="btn btn-success btn-lg" *ngIf="!isSubmitted">{{header}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<div class="d-flex margin-bottom-15">
  <!--<h2 class="mainhead "><span class="text">City List</span></h2>-->
  <div class="ml-auto d-flex">
    <div class="search-sec margin-right-10">
      <input class="form-control" [(ngModel)]="searchText" type="text" maxlength="30" (keyup)='search($event.target.value)' placeholder="Search">
      <i class="fa fa-search icon" aria-hidden="true"></i>
    </div>
    <a class="filter btn  btn-circle btn-green adduserbtn ml-auto" [ngClass]="{'disable-link':IsPDeleted}" href="javascript:void(0);" placement="left" tooltip="Add Deal Contact" (click)="create(false);"><i class="fa fa-plus icon" aria-hidden="true"></i></a>
  </div>
</div>
<div class="table-responsive">

  <table class="table basictable row-border hover" datatable id="deal-contact-list" [dtOptions]="dtOptions">

    <thead>
      <tr>
        <th data-orderable="false">
          Actions
        </th>
        <th>
          First Name
        </th>
        <th>
          Last Name
        </th>
        <th>
          Contact Type
        </th>
        <th>
          Email
        </th>
        <th>
          Phone
        </th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let deal of filterData; let i=index">
        <td style="width:10%">
          <a href="javascript:void(0);" (click)="edit(deal);" class="blueone" tooltip="Edit" placement="top" *ngIf="deal.ContactTypeId > 0">
            <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
          </a>
          <a href="javascript:void(0);" (click)="openDeleteModal(RemoveDealContact, '', deal.Id);" class="blueone" tooltip="Remove" placement="top" *ngIf="deal.ContactTypeId > 0">
            <i class="icofont icofont-close" aria-hidden="true"></i>
          </a>
        </td>
        <td>{{deal.FirstName}}</td>
        <td>{{deal.LastName}}</td>
        <td>{{deal.ContactType}}</td>
        <td>{{deal.Email ? deal.Email : '-'}}</td>
        <td>{{deal.Phone ? (deal.Phone | phone) : '-'}}</td>


      </tr>
    </tbody>
    <tfoot>
      <tr *ngIf="filterData?.length == 0&&!IsLoading">
        <td colspan="6" class="no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
<ng-template #RemoveDealContact>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Deal Contact</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefDelete.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to remove this Deal Contact ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefDelete.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="delete();">Remove</button>
    </div>
  </div>

</ng-template>
